import { memo } from "react";

import { Icon } from "@react/components/Icon";
import { tw } from "classnames";

const styles = {
  loadingOverlay: tw(
    "flex",
    "w-full",
    "h-full",
    "items-center",
    "justify-center",
    "before:content-['']",
    "before:absolute",
    "before:top-0",
    "before:bottom-0",
    "before:left-0",
    "before:right-0",
    "before:bg-background-primary",
    "before:opacity-50"
  ),
  loadingWheel: tw("animate-spin", "w-8", "h-8", "text-primary"),
};

const LoadingOverlayViewBase = () => {
  return (
    <div className={styles.loadingOverlay}>
      <Icon className={styles.loadingWheel} name="loading-wheel" />
    </div>
  );
};

export const LoadingOverlayView = memo(LoadingOverlayViewBase);
